export default __webpack_public_path__ + "static/media/outcess11.89fad1c9.jpeg";